<template>
  <VTextField
    ref="input"
    :label="label"
    v-currency="options"
    :value="formattedValue"
    :readonly="readonly"
    @change="onChange"
    @input="onInput"
    @keyup.enter="seleccionar"
  />
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "Importe2",
  props: {
    refocus: String,
    label: String,
    readonly: Boolean,
    value: {
      type: Number,
      default: null
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formattedValue: null
    };
  },
  watch: {
    value(valor) {
      this.setValue(valor);
    }
  },
  mounted() {
    this.setValue(this.value);
  },
  created() {
    eventBus.$on("setearFocoImporte", this.setearFoco);
  },
  beforeDestroy() {
    eventBus.$off("setearFocoImporte", this.setearFoco);
  },
  methods: {
    setValue(value) {
      this.$ci.setValue(this.$refs.input, value);
    },
    onInput(value) {
      this.$emit("input", this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    },
    onChange(value) {
      this.$emit("change", this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    },
    setearFoco(ref) {
      if (ref == this.refocus) this.$refs.input.focus();
    },
    seleccionar() {
      this.$emit("seleccionarItem", this.$ci.getValue(this.$refs.input));
    }
  }
};
</script>
